import { render, staticRenderFns } from "./ChatWorkHistory.vue?vue&type=template&id=e9a281d0&scoped=true"
import script from "./ChatWorkHistory.vue?vue&type=script&lang=js"
export * from "./ChatWorkHistory.vue?vue&type=script&lang=js"
import style0 from "./ChatWorkHistory.vue?vue&type=style&index=0&id=e9a281d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a281d0",
  null
  
)

export default component.exports